import { PlaceOutlined } from '@mui/icons-material';
import { Box, Skeleton } from '@mui/material';
import AddressLabel from 'src/features/addresses/presentation/components/AddressLabel';
import useAddressList from '../../hooks/useAddressList';

const AddressDisplay = () => {
  const { mainAddress, isLoading } = useAddressList();

  if (isLoading) {
    return (
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          p: 2,
          bgcolor: 'background.paper',
          borderRadius: 1,
        }}
      >
        <Skeleton variant="circular" width={24} height={24} />
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width="60%" height={24} />
          <Skeleton variant="text" width="80%" height={20} />
        </Box>
      </Box>
    );
  }

  if (!mainAddress) {
    return null;
  }

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        bgcolor: 'background.paper',
        borderRadius: 1,
      }}
    >
      <PlaceOutlined sx={{ color: 'text.secondary' }} fontSize="medium" />
      <AddressLabel address={mainAddress} />
    </Box>
  );
};

export default AddressDisplay;
